import { hyphenatePhoneNumber } from '@constants/phoneNumbers';
import { formatUtcDateToDateString } from '@utils/formatDate';
import { OpenbookCarriers } from '@utils/index';
import { titleCase } from 'title-case';
import ClientName from './ClientName';
import StatusTag from './StatusTag';

// Formatters
export const columnTypeToFormatter = {
  date: formatUtcDateToDateString,
  text: (value) => (value ? titleCase(value.toLowerCase()) : '-'),
  phone: (phoneNumber) => hyphenatePhoneNumber(phoneNumber),
  node: (node) => node,
};

// Applications Columns
export const applicationsColumns = [
  {
    label: 'Name',
    key: 'firstName',
    render: (row) => `${row.firstName} ${row.lastName}`,
    type: 'text',
  },
  {
    label: 'Status',
    key: 'status',
    render: (row) => StatusTag(row),
    type: 'node',
  },
  {
    label: 'Reason',
    key: 'statusReason',
    type: 'text',
  },
  {
    label: 'Signature Date',
    key: 'signatureDate',
    type: 'date',
  },
  {
    label: 'Effective Date',
    key: 'effectiveDate',
    type: 'date',
  },
  {
    label: 'Carrier',
    key: 'carrier',
    render: (row) => OpenbookCarriers[row.carrier].name,
    type: 'text',
  },
  {
    label: 'CMS ID',
    key: 'cmsId',
    type: 'text',
  },
  {
    label: 'Plan Type',
    key: 'planType',
  },
  {
    label: 'Agent Name',
    key: 'agentName',
    type: 'text',
  },
];

// Book Columns
export const bookColumns = [
  {
    label: 'Name',
    key: 'firstName',
    render: (client, isExpanded) => {
      return ClientName({
        isExpanded,
        name: `${client.firstName} ${client.lastName}`,
      });
    },
    type: 'node',
  },
  {
    label: 'Email',
    key: 'email',
    render: (client) => {
      return `${client.plans.find((plan) => plan.email)?.email || '-'}`;
    },
    type: 'text',
  },
  {
    label: 'Status',
    key: 'status',
    render: (client) => StatusTag(client.plans[0]),
    type: 'node',
  },
  {
    label: 'Reason',
    render: (client) => (client.plans[0].statusReason === 'Unknown' ? '-' : client.plans[0].statusReason),
  },
  {
    label: 'Carrier',
    render: (client) => OpenbookCarriers[client.plans[0].carrier].name,
  },
  {
    label: 'Plans',
    render: (client) => client.plans.map((plan) => plan.planType).join(', '),
  },
];
